export enum ErrorCode {
    Success                                 = 0,
    InvalidMethod                           = 1000,
    NotAuthorized                           = 1001,
    DatabaseFailure                         = 1002,
    Deprecated                              = 1004,
    HeadersMissing                          = 1005,
    BadRequest                              = 1010,
    GeneralError                            = 1020,
    FieldsMissing                           = 1030,
    BadEnum                                 = 1031,
    EmailLengthInvalid                      = 2000,
    EmailFormatInvalid                      = 2001,
    UserDoesntExists                        = 2010,
    UserBlocked                             = 2020,
    PasswordDoesntMatch                     = 2030,
    PasswordLengthInvalid                   = 2040,
    EmailTaken                              = 2050,
    FirstNameLengthInvalid                  = 2060,
    LastNameLengthInvalid                   = 2061,
    CompanyNameLengthInvalid                = 2070,
    PhonePrefixDoesntExist                  = 2080,
    CountryCodeDoesntExist                  = 2081,
    ForgotPasswordDoesntExist               = 2090,
    ForgotPasswordExpired                   = 2091,
    PocDoesntExist                          = 2100,
    InvalidFile                             = 3000
}



// WEBPACK FOOTER //
// ./src/app/enums/error-codes.ts